/**
 * Facet Search.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Teaser from '../components/Teaser';
import Loader from '../components/Loader';
import Facets from '../components/Facets';
import Pagination from '../components/Pagination';
import fetchFilters from '../actions/fetchFilters';
import setSearchUrl from '../actions/setSearchUrl';

class FacetSearch extends Component {

	constructor ( props ) {
		super();
	}

	componentDidMount () {

		/**
		 * Filters dienen eerst ingeladen te worden, anders kunnen URL parameters niet gematcht worden om actieve data op te halen
		 */
		this.props.dispatch( fetchFilters() );

		/**
		 * Check screen size om te kijken of je op mobiel of desktop zit.
		 */

		//this.props.dispatch( checkScreenSize() );
	}

	render () {

		const {
			teasers,
			pending,
			activeOrderBy,
			totalResults
		} = this.props.state;

		const handleOrderBy = ( e ) => {
			this.props.dispatch( setSearchUrl( 'order', e.target.value, null ) )
		}

		return (
			<div className="u-padding-y-xxl">
				<div className="o-container">
					<h1 className="u-text-center u-margin-bottom-xxl">Zoek artikels</h1>
					{ pending ?
						<Loader /> :
						<div className="c-search">
							<div className="c-search__facets">
								<Facets />
							</div>
							{
								teasers && teasers.length > 0 ?
									<>
										<div class="c-search__filters o-flex o-flex-justify-content-between o-flex-align-items-center">
											<p className="c-facets__amount">
												Gevonden artikels: { totalResults }
											</p>
											<div className="c-facets__select">
												<label>
													Sort by:
												</label>
												<select onChange={ e => { handleOrderBy( e ); } } value={ activeOrderBy }>
													<option value="date">
														Date
													</option>
													<option value="title">
														Title
													</option>
												</select>
											</div> 
										</div>
										<div className="c-search__articles">
											<div className="o-grid o-grid-2-lg o-grid-gap-s">
												{ teasers.map( ( teaser ) =>
													<Teaser teaser={ teaser } />
												) }
											</div>

										</div>
										<Pagination />
									</>
									:
									<p>Geen resultaten gevonden</p>
							}
						</div>
					}
				</div>
			</div>
		);
	}
}

function mapStateToProps ( state ) {
	return { state };
}

export default connect( mapStateToProps )( FacetSearch );
